'use client'
import { QueryClient } from '@tanstack/query-core'

declare global {
	var __RQ_CLIENT__: QueryClient | undefined
}

export const getQueryClient = () => {
	if (!globalThis.__RQ_CLIENT__) {
		globalThis.__RQ_CLIENT__ = new QueryClient({
			defaultOptions: {
				queries: {
					staleTime: 60_000,
					gcTime: 5 * 60_000,
					retry: 1,
				},
			},
		})
	}
	return globalThis.__RQ_CLIENT__
}
